<template>
	<div id="doctor">
		<!-- 顶部操作栏 -->
		<div class="toolbar">
			<div class="toolbar-left">
				<el-input v-model="nameKeyword" prefix-icon="el-icon-search" clearable
					placeholder="搜索姓名/手机号/医院" size="small" class="search-input"
					@keyup.enter.native="searthDoctorFun()" />
				<el-select v-model="departVal" placeholder="科室" clearable filterable size="small"
					@change="getDoctorList()">
					<el-option v-for="item in department" :key="item.name" :label="item.name"
						:value="item.name" />
				</el-select>
				<el-select v-model="titVal" placeholder="职称" clearable filterable size="small"
					@change="getDoctorList()">
					<el-option v-for="item in title" :key="item.name" :label="item.name"
						:value="item.name" />
				</el-select>
				<el-button type="primary" size="small" icon="el-icon-search"
					@click="searthDoctorFun()">搜索</el-button>
			</div>
			<div class="toolbar-right">
				<el-button size="small" icon="el-icon-plus" type="primary"
					@click="creatorDoctor()">新增医生</el-button>
				<el-button size="small" icon="el-icon-upload2"
					@click="batchOptn = true">批量导入</el-button>
				<el-badge :value="waitTotal" :hidden="!waitTotal" class="wait-badge">
					<el-button size="small" icon="el-icon-bell"
						@click="toWaitDoctor()">待审核</el-button>
				</el-badge>
			</div>
		</div>

		<!-- 医生表格 -->
		<el-table :data="doctorList" style="width: 100%" v-loading="loading"
			@row-click="toDoctorInfo" class="doctor-table" stripe>
			<el-table-column label="姓名" min-width="120">
				<template slot-scope="scope">
					<div class="name-cell">
						<div class="avatar-circle">{{ (scope.row.fullName || '?').substring(0,1) }}</div>
						<span>{{ scope.row.fullName || scope.row.phoneNumber }}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="phoneNumber" label="手机号" width="140" />
			<el-table-column prop="hospital" label="所在医院" min-width="180" show-overflow-tooltip />
			<el-table-column prop="department" label="科室" width="120" />
			<el-table-column prop="title" label="职称" width="120" />
			<el-table-column label="状态" width="90" align="center">
				<template slot-scope="scope">
					<el-tag size="mini" :type="scope.row.status === 'SUCCESS' ? 'success' : 'warning'">
						{{ scope.row.status === 'SUCCESS' ? '已审核' : '待审核' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="80" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click.stop="toDoctorInfo(scope.row)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 空状态 -->
		<div class="empty-state" v-if="!loading && (!doctorList || !doctorList.length)">
			<i class="el-icon-user" style="font-size: 40px; color: #ddd;"></i>
			<p>暂无医生数据</p>
		</div>

		<!-- 分页 -->
		<el-pagination background layout="total, prev, pager, next" :total="total"
			:page-size="size" :current-page.sync="page" class="pagination"
			@current-change="getDoctorList" />

		<!-- 批量导入弹窗 -->
		<el-dialog title="批量注册医生" :visible.sync="batchOptn" width="460px">
			<el-form ref="form" :model="batchForm" label-width="auto" label-position="top"
				v-loading="loading">
				<el-form-item label="项目">
					<el-select v-model="batchForm.projectId" placeholder="请选择项目"
						style="width: 100%;" filterable>
						<el-option v-for="item in projectList" :key="item.id"
							:label="item.projectName" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item label="上传文件">
					<el-upload :action="`${baseUrl}/sign/live/doctor/uploadFile`"
						:on-success="handleSuccess" :file-list="fileList"
						:on-exceed="handleExceed" :on-remove="handleRemove" :limit="1">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
					<a href="//life-oasis.oss-cn-beijing.aliyuncs.com/video/newtemplate/%E5%8A%B3%E5%8A%A1%E5%8D%8F%E8%AE%AE%E6%98%8E%E7%BB%86.xlsx"
						style="font-size: 12px; color: #409EFF;" target="_blank">下载模版</a>
				</el-form-item>
				<div style="display: flex; justify-content: flex-end; gap: 8px;">
					<el-button size="small" @click="batchOptn = false">取消</el-button>
					<el-button size="small" type="primary" @click="submit()">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import {
	doctorList,
	waitDoctors,
	importProjectUser,
	projectList, officialGetDoctorList, oprojectList
} from '@/request/api.js';
import title from '@/assets/title.json';
import department from '@/assets/department.json';
import baseUrl from "@/request/config.js"

export default {
	name: 'doctor',
	data() {
		return {
			loading: false,
			batchOptn: false,
			nameKeyword: '',
			hospitalKeywords: '',
			phonenumberKeywords: '',
			page: 1,
			size: 15,
			total: 0,
			doctorList: '',
			waitDocs: '',
			waitTotal: 0,
			department: '',
			departVal: '',
			title: '',
			titVal: '',
			orderBy: '综合排序',
			batchForm: {
				projectId: '',
			},
			baseUrl: '',
			fileList: [],
			projectList: []
		}
	},
	created() {
		this.title = title;
		this.baseUrl = baseUrl;
		this.department = department;
		this.getDoctorList();
		this.getwaitDoctors();
		this.getProjectListFun();
	},
	methods: {
		submit() {
			if (!this.batchForm.projectId) {
				this.$alert('请选择项目', '提示', { confirmButtonText: '确定' });
			} else if (!this.fileList[0]) {
				this.$alert('请上传文件', '提示', { confirmButtonText: '确定' });
			} else {
				this.loading = true;
				let data = {
					projectId: this.batchForm.projectId,
					fileName: this.fileList[0].fileName
				}
				importProjectUser(data).then(res => {
					if (res.code == 200) {
						this.batchOptn = false;
						this.$message({ message: res.data, type: 'success' });
						this.getDoctorList();
					} else {
						let errorMsg = (res.msg || '')
							.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
							.split('；').filter(item => item.trim() !== '')
							.map((item, index) => `${index + 1}. ${item}`).join('<br>');
						this.$message.warning({ dangerouslyUseHTMLString: true, message: errorMsg, duration: 5000 });
					}
					this.loading = false;
				})
			}
		},
		handleRemove() { this.fileList = []; },
		handleSuccess(res, file) {
			this.fileList.push({ fileName: res, name: file.name });
		},
		handleExceed() { this.$message.warning('只允许上传一个文件'); },
		getProjectListFun() {
			oprojectList({ projectStatus: 'UNDERWAY', size: 500 }).then(res => {
				if (res.code == 200) this.projectList = res.data.records;
			})
		},
		getwaitDoctors() {
			waitDoctors().then(res => {
				if (res.code == 200) {
					this.waitDocs = res.data.records;
					this.waitTotal = res.data.total;
				}
			})
		},
		toWaitDoctor() { this.$router.push({ name: 'reviewdoctor' }); },
		toDoctorInfo(item) {
			this.$router.push({ name: 'doctorinfo', query: { dId: item.id } });
		},
		creatorDoctor() { this.$router.push({ name: 'creatdoc' }); },
		searthDoctorFun() { this.page = 1; this.getDoctorList(); },
		getDoctorList() {
			this.loading = true;
			let data = { current: this.page, size: this.size };
			if (this.nameKeyword) data.fullName = this.nameKeyword;
			if (this.departVal) data.department = this.departVal;
			if (this.titVal) data.title = this.titVal;
			if (this.orderBy) data.orderBy = this.orderBy;
			officialGetDoctorList(data).then(res => {
				if (res.code == 200) {
					this.doctorList = res.data.records;
					this.total = res.data.total;
				}
				this.loading = false;
			}).catch(() => { this.loading = false; })
		}
	}
}
</script>

<style lang="scss" scoped>
#doctor {
	padding: 20px;

	.toolbar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;
		flex-wrap: wrap;
		gap: 10px;

		.toolbar-left {
			display: flex;
			gap: 8px;
			align-items: center;
			flex-wrap: wrap;

			.search-input { width: 240px; }
			.el-select { width: 120px; }
		}

		.toolbar-right {
			display: flex;
			gap: 8px;
			align-items: center;
		}
	}

	.doctor-table {
		border-radius: 8px;
		overflow: hidden;
		cursor: pointer;

		.name-cell {
			display: flex;
			align-items: center;
			gap: 8px;

			.avatar-circle {
				width: 32px;
				height: 32px;
				border-radius: 50%;
				background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
				color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				font-weight: 600;
				flex-shrink: 0;
			}
		}
	}

	.empty-state {
		text-align: center;
		padding: 40px 0;
		color: #c0c4cc;
		p { margin-top: 8px; font-size: 14px; }
	}

	.pagination {
		text-align: center;
		margin-top: 16px;
	}

	.wait-badge {
		::v-deep .el-badge__content {
			z-index: 10;
		}
	}
}
</style>